import { useImageFilters } from "./useImageFilter";

export function imagePath(image360: string, imgNumber?: string, imgSize?: string) {
  const baseUrl = process.env.NEXT_PUBLIC_IMAGE_PATH;
  const imageSlug = image360;
  const imageNumber = imgNumber;
  const imageSize = imgSize;
  const imageFormat = ".jpg";

  return `${baseUrl}${imageSlug}${imageSize}/${imageNumber}${imageFormat}`;
}

const TIRE_IMAGE_PATH = process.env.NEXT_PUBLIC_IMG_CMS_PATH || "https://cdn.pneufree.com.br/CMS";

export function shoppingImagePath(slug: string) {
  const baseUrl = TIRE_IMAGE_PATH;
  const imageType = "shopping.jpg";

  return `${baseUrl}${slug}${imageType}`;
}

export function cartImagePath(slug: string) {
  const baseUrl = process.env.NEXT_PUBLIC_CLEAR_IMAGE_PATH;

  return `${baseUrl}${slug}`;
}

export function vehicleImagePath(brandName: string) {
  const baseUrl = process.env.NEXT_PUBLIC_VEHICLE_IMAGE_PATH;
  const brand = brandName?.replace(" ", "-");
  const imageFormat = ".png";

  return `${baseUrl}${brand}${imageFormat}`;
}

export function marcationPath(marcation: string) {
  const baseUrl = process.env.NEXT_PUBLIC_VEHICLE_IMAGE_PATH;
  let brand = marcation.replace(" ", "-");
  const imageFormat = ".png";

  if (marcation == "ar" || marcation == "arr") {
    brand = "ALFA-ROMEO";
  } else if (
    marcation == "a6a" ||
    marcation == "a7a" ||
    marcation == "am4" ||
    marcation == "am8" ||
    marcation == "am9" ||
    marcation == "amp" ||
    marcation == "ams" ||
    marcation == "amv" ||
    marcation == "a8a"
  ) {
    brand = "ASTON-MARTIN";
  } else if (
    marcation == "ao" ||
    marcation == "ao1" ||
    marcation == "aoe" ||
    marcation == "ro1" ||
    marcation == "ro2" ||
    marcation == "r02"
  ) {
    brand = "AUDI";
  } else if (marcation == "b" || marcation == "b1" || marcation == "bc" || marcation == "bl") {
    brand = "BENTLEY";
  } else if (marcation == "bmw" || marcation == "bmw-k1" || marcation == "bmw-s1") {
    brand = "BMW";
  } else if (
    marcation == "k1" ||
    marcation == "f" ||
    marcation == "f01" ||
    marcation == "f03" ||
    marcation == "02"
  ) {
    brand = "FERRARI";
  } else if (marcation == "j") {
    brand = "JAGUAR";
  } else if (marcation == "l" || marcation == "l1") {
    brand = "LAMBORGHINI";
  } else if (
    marcation == "e-lr" ||
    marcation == "lr" ||
    marcation == "lr1" ||
    marcation == "lr2" ||
    marcation == "lr3" ||
    marcation == "lr4" ||
    marcation == "lr5"
  ) {
    brand = "LAND-ROVER";
  } else if (marcation == "ls") {
    brand = "LOTUS";
  } else if (marcation == "mgt") {
    brand = "MASERATI";
  } else if (
    marcation == "mo" ||
    marcation == "mo1" ||
    marcation == "moe" ||
    marcation == "mo-s" ||
    marcation == "mo-v"
  ) {
    brand = "MERCEDES-BENZ";
  } else if (
    marcation == "n0" ||
    marcation == "n1" ||
    marcation == "n2" ||
    marcation == "n3" ||
    marcation == "n4" ||
    marcation == "n5" ||
    marcation == "na0" ||
    marcation == "nf0"
  ) {
    brand = "PORSCHE";
  } else if (marcation == "vol") {
    brand = "VOLVO";
  } else if (marcation == "bmw moe") {
    brand = "BMW-MBZ";
  } else if (marcation == "mo-ro1") {
    brand = "AUDI-MBZ";
  } else if (marcation == "j-lr") {
    brand = "JAG-LR";
  } else if (marcation == "bmw-mini") {
    brand = "BMW-MINI";
  }
  return `${baseUrl}${brand}${imageFormat}`;
}

export function imageInmetroPath(inmetroType: any, inmetroRating: any) {
  const baseUrl = process.env.NEXT_PUBLIC_INMETRO_PATH;
  const imageFormat = ".png";

  if (inmetroRating != undefined || inmetroRating != null) {
    const rating = inmetroRating.toString().toLowerCase();

    return `${baseUrl}/LINGLONG/images/Site/etiqueta/${inmetroType}-${rating}${imageFormat}`;
  } else {
    return null;
  }
}

export function imageInmetroFooter(inmetroType: string) {
  const baseUrl = process.env.NEXT_PUBLIC_INMETRO_PATH;
  const imageFormat = ".png";

  return `${baseUrl}/LINGLONG/images/Site/etiqueta/${inmetroType}${imageFormat}`;
}

export function partnerImagePath(id: string) {
  const imageFormat = ".jpg";
  const baseUrl = process.env.NEXT_PUBLIC_PARTNER_IMAGE_PATH;

  return `${baseUrl}${id + imageFormat}`;
}

export function categoryCar(type: string) {
  const imageFormat = ".png";
  const baseUrl = process.env.NEXT_PUBLIC_CATEGORY_IMAGE_PATH;

  if (type == "Automóvel de Passeio") {
    return baseUrl + "carro" + imageFormat; // #3d7dc0
  } else if (type == "Camionete/SUV") {
    return baseUrl + "suv" + imageFormat; // #f9cc4f
  } else if (type == "Carga") {
    return baseUrl + "carga" + imageFormat; // #f37321
  } else if (type == "Vans e Veículos Comerciais") {
    return baseUrl + "van" + imageFormat; // #f1536b
  }
}

export function useCategory(type: string) {
  const ImageFormat = ".png";
  const BaseUrl = process.env.NEXT_PUBLIC_CATEGORY_IMAGE_PATH;
  if (type == "Automóvel de Passeio") {
    return [type, BaseUrl + "carro" + ImageFormat, useImageFilters("#3d7dc0")];
  } else if (type == "Camionete/SUV") {
    return [type, BaseUrl + "suv" + ImageFormat, useImageFilters("#f9cc4f")];
  } else if (type == "Carga") {
    return [type, BaseUrl + "carga" + ImageFormat, useImageFilters("#f37321")];
  } else if (type == "Vans e Veículos Comerciais") {
    return [type, BaseUrl + "van" + ImageFormat, useImageFilters("#f1536b")];
  } else {
    return [null, null, null];
  }
}
